type SimilaridadeConteudoRow = {
  CONT_LIQUIDO?: string | number | null;
  CONT_LIQUIDO_UND_MEDIDA?: string | null;
  UNIDADE_MEDIDA?: string | null;
  UNIDADE_MEDIDA_CONTEUDO?: string | null;
  UNIDADE?: string | null;
  MEDIDA?: string | null;
};

const parseNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "") return null;
  const number = Number(String(value).replace(",", "."));
  return Number.isNaN(number) ? null : number;
};

export function formatConteudoLiquidoSimilaridade(
  row: SimilaridadeConteudoRow,
  emptyFallback: string = "---"
): string {
  const valor = parseNumber(row.CONT_LIQUIDO);
  if (valor === null) return emptyFallback;

  const unidade = (
    row.CONT_LIQUIDO_UND_MEDIDA ||
    row.UNIDADE_MEDIDA ||
    row.UNIDADE_MEDIDA_CONTEUDO ||
    row.UNIDADE ||
    row.MEDIDA ||
    ""
  )
    .toString()
    .trim();

  if (!unidade) return String(valor);
  return `${valor} ${unidade}`;
}
